import { withItemDrag } from './withItemDrag';
import { withItemDropTarget } from './withItemDropTarget';
export const withItemDragAndDrop = Wrapped => {
  return withItemDropTarget(withItemDrag(Wrapped));
};